module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_14.8c90e4f3.png";